import React,{Fragment} from 'react'
import Link from "next/link";
import {applyLang, LangSelect} from "../../i18n";
import {Divider} from "antd";
import {ASSET_URL} from "../../config";

export default class Header extends React.Component{

    render()
    {
        const {context,campagneData}=this.props
        const {org,config}=context
        const menu=org.web_menu

        return (
            <header style={{backgroundColor: "#FFF", height: 70,padding:"10px 0"}}>
                <div className={"container d-flex justify-content-between align-items-center"}>
                    <div className={"d-flex align-items-center"}>
                        {!campagneData?.config?.hideOrg && (
                            <img
                                src={campagneData?.config["ald.logo"] ? ASSET_URL + "/" + campagneData.config["ald.logo"] : org.logo}
                                style={{height: 45, marginLeft: 20}}/>
                        )}
                    </div>

                    <div>
                        <LangSelect full context={context}/>
                    </div>
                </div>
            </header>

        )
    }

}
